import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';

import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessor } from '@services/ui-services/control-value.accessor';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  imports: [CommonModule, CeIconComponent, MatTooltipModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent extends ControlValueAccessor {
  @Input() id: string = '';

  @Input() label: string = '';

  @Input()
  input_name = 'input_checkbox';

  @Input()
  checked: boolean = false;

  @Input()
  lock = false;

  @Input()
  title = 'This record is locked. You can’t take any actions.';

  @Input()
  disabled = false;

  @Input()
  indeterminate = false;

  @Output() onCheckChange = new EventEmitter<boolean>();

  writeValue(value: boolean): void {
    this.checked = value ?? false;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onClick($event: MouseEvent) {
    $event.stopPropagation();
  }

  handleChange($event: any) {
    $event.stopPropagation();
    this.checked = $event.target.checked;
    this.onCheckChange.emit(this.checked);
    this.onChange?.(this.checked);
  }

  handleBlur() {
    this.onTouched?.();
  }
}
